function DateTimeIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M2.5 7C2.5 4.79086 4.29086 3 6.5 3H24.5C26.7091 3 28.5 4.79086 28.5 7V15.5C28.5 16.0523 28.0523 16.5 27.5 16.5C26.9477 16.5 26.5 16.0523 26.5 15.5V7C26.5 5.89543 25.6046 5 24.5 5H6.5C5.39543 5 4.5 5.89543 4.5 7V25C4.5 26.1046 5.39543 27 6.5 27H14C14.5523 27 15 27.4477 15 28C15 28.5523 14.5523 29 14 29H6.5C4.29086 29 2.5 27.2091 2.5 25V7Z'
        />
        <path fillRule='evenodd' clipRule='evenodd' d='M27.5 13H4.5V11H27.5V13Z' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.5 1C11.0523 1 11.5 1.44772 11.5 2L11.5 8C11.5 8.55228 11.0523 9 10.5 9C9.94771 9 9.5 8.55228 9.5 8L9.5 2C9.5 1.44772 9.94772 1 10.5 1Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M20.5 1C21.0523 1 21.5 1.44772 21.5 2L21.5 8C21.5 8.55228 21.0523 9 20.5 9C19.9477 9 19.5 8.55228 19.5 8L19.5 2C19.5 1.44772 19.9477 1 20.5 1Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M23.5 30C26.2614 30 28.5 27.7614 28.5 25C28.5 22.2386 26.2614 20 23.5 20C20.7386 20 18.5 22.2386 18.5 25C18.5 27.7614 20.7386 30 23.5 30ZM23.5 32C27.366 32 30.5 28.866 30.5 25C30.5 21.134 27.366 18 23.5 18C19.634 18 16.5 21.134 16.5 25C16.5 28.866 19.634 32 23.5 32Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M23.5 21.5C24.0523 21.5 24.5 21.9477 24.5 22.5V25.0858L25.7071 26.2929C26.0976 26.6834 26.0976 27.3166 25.7071 27.7071C25.3166 28.0976 24.6834 28.0976 24.2929 27.7071L22.7929 26.2071C22.6054 26.0196 22.5 25.7652 22.5 25.5V22.5C22.5 21.9477 22.9477 21.5 23.5 21.5Z'
        />
      </svg>
    </span>
  );
}

export default DateTimeIcon;
